import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackButton = withStyles((theme: Theme) => ({
  root: {},
}))((props: any) => (
  <IconButton color="primary" aria-label="back to preview step" {...props} size="large">
    <ArrowBackIcon />
  </IconButton>
));
export default BackButton;
